import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import dialog from "@/extension/h5/dialog"

addCustomWidgetSchema({
  type: 'dialog',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '',
    label: '弹窗选择',
    title: '标题',
    columnWidth: '200px',
    required: false,
    labelWidth: '110',
    labelHidden: true,
    labelAlign: 'label-right-align',
    labelKey: 'dicValue',
    valueKey: 'dicKey',
    textAlign: "left",//文字对齐方式
    placeholder: '',
    maxNum: 9999,
    optionItems: [
      {
        "label": "无",
        "value": "0"
      },
      {
        "label": "子宫肌瘤",
        "value": "1"
      },
      {
        "label": "不孕症",
        "value": "2"
      },
      {
        "label": "辅助生殖技术",
        "value": "3"
      },
      {
        "label": "其它",
        "value": "4"
      },
      {
        "label": "异位妊娠",
        "value": "5"
      },
      {
        "label": "异位妊娠1",
        "value": "6"
      },
      {
        "label": "异位妊娠2",
        "value": "7"
      },
      {
        "label": "异位妊娠3",
        "value": "8"
      }
    ],
    //-------------------
    customClass: '',  //自定义css类名
    //-------------------
    onCreated: '',
    onMounted: '',
    onChange: '',
  }
})  //加载组件Json Schema

Vue.component(dialog.name, dialog)  //注册组件

let maxNumOptions = [
  { label: '单选', value: 1 },
  { label: '多选', value: 9999 }
]
PERegister.registerCPEditor('maxNum', 'maxNum-editor',
  PEFactory.createRadioGroupEditor('maxNum', '单选/多选', { optionItems: maxNumOptions }))

PERegister.registerCPEditor('labelKeyName', 'labelKeyName-editor',
  PEFactory.createInputTextEditor('labelKeyName', '选项标签名'))
PERegister.registerCPEditor('valueKeyName', 'valueKeyName-editor',
  PEFactory.createInputTextEditor('valueKeyName', '选项值名'))